<template>
  <main>
    <!-- Introduction -->
    <section class="mb-8 py-20 text-white text-center relative">
      <div class="absolute inset-0 w-full h-full bg-contain introduction-bg"
        style="background-image: url(assets/img/header.png)"></div>
      <div class="container mx-auto">
        <div class="text-white main-header-content">
          <h1 class="font-bold text-5xl mb-5" v-if="!userLoggedIn">Welcome to Care on Wheels</h1>
          <h1 class="font-bold text-5xl mb-5" v-else>
            Welcome {{ this.displayName }} to Care on Wheels</h1>
          <p class="w-full md:w-8/12 text-xl mx-auto">
          A voice controlled bot that carries a first aid kit and can be used to check temperature,
          heart rate and oxygen level in blood. This data is displayed on a dashboard for keeping a
          check on the user's recent health records.
          </p>
        </div>
      </div>
      <!-- <img class="relative block mx-auto mt-5 -mb-20 w-auto max-w-full"
        src="assets/img/introduction-music.png" /> -->
    </section>
    <transition name="fade" mode="out-in">
      <section>
          <component :is="'script'"  src="https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1"> </component>
          <df-messenger
            intent="WELCOME"
            chat-title="Care-On-Wheels"
            agent-id="3f21d1f6-08aa-4ed5-a4a6-c3aa1a935b25"
            language-code="en"
            chat-icon="assets/img/docImg.png"
          ></df-messenger>
        <img v-if="!userLoggedIn"
          class="absolute left-0 bottom-0 max-w-sm h-auto transition-shadow ease-in-out
                duration-300 shadow-none hover:shadow-xl"
          src="assets/img/doctor.png"
        />
        <div v-else>
          <transition name="fade" mode="out-in">
            <div>
              <img class="absolute left-0 bottom-0  max-w-sm h-auto transition-shadow ease-in-out
                    duration-300 shadow-none hover:shadow-xl"
              src="assets/img/doctor.png" />
              <div>
                <img class="absolute ml-64" src="assets/img/callout.png" />
                <!-- <a href="dash.html">
                  <h3 class="absolute ml-72 mt-14 font-bold text-2xl">
                    Have a look at your <br>
                    dashboard here
                  </h3>
                </a> -->
                <router-link :to="{name: 'dashboard'}">
                  <h3 class="absolute ml-72 mt-14 font-bold text-2xl">
                    Have a look at your <br>
                    dashboard here
                  </h3>
                </router-link>
              </div>
            </div>
          </transition>
        </div>
      </section>
    </transition>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import { auth } from '@/includes/firebase';

export default {
  name: 'Home',
  data() {
    return {
      displayName: '',
    };
  },
  computed: {
    ...mapState(['userLoggedIn']),
  },
  mounted() {
    if (this.userLoggedIn) {
      this.displayName = auth.currentUser.displayName;
    }
  },
};
</script>

<style>
.fade-enter-from{
  opacity: 0;
}

.fade-enter-active{
  transition: all 0.5s linear;
}

.fade-leave-to{
  transition: all 0.5s linear;
  opacity: 0;
}

df-messenger{
--df-messenger-bot-message: #0F52BA;
--df-messenger-button-titlebar-color: #191970;
--df-messenger-chat-background-color:#F0FFFF;
--df-messenger-font-color:white;
--df-messenger-send-icon:#5C4298;
--df-messenger-user-message: #6495ED;
transform: translateX(50%) translateY(50%);
}
</style>
